import {
  CHANGE_TABS,
  SET_IS_EDIT_SUCCESS,
  SET_IS_IMG_UPLOADED_SUCCESS,
  SET_LOADING,
  SET_PASSWORD_ERROR_MESSAGE,
  SET_TABS,
  SET_ERROR,
  SET_IS_EDIT_PREFERENCES_SUCCESS,
  CLEAR_PHONE_ERROR,
} from './AccountSettingsConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setAccountSettingsError(errorMsg) {
  return {
    type: SET_ERROR,
    payload: errorMsg,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setIsEditSuccess(newStatus) {
  return {
    type: SET_IS_EDIT_SUCCESS,
    payload: newStatus,
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setIsImgUploaded(newStatus) {
  return {
    type: SET_IS_IMG_UPLOADED_SUCCESS,
    payload: newStatus,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPasswordErrorMessage = (message) => ({
  type: SET_PASSWORD_ERROR_MESSAGE,
  payload: message,
})

export const setTabs = () => ({
  type: SET_TABS,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function changeTabs(title) {
  return {
    type: CHANGE_TABS,
    payload: title,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setSettingsPageLoading = (newStatus) => ({
  type: SET_LOADING,
  payload: newStatus,
})

export const setIsEditPreferencesSuccess = (value = false) => ({
  type: SET_IS_EDIT_PREFERENCES_SUCCESS,
  payload: value,
})

export const clearPhoneErrorAccount = () => ({
  type: CLEAR_PHONE_ERROR,
})
